module.exports = __webpack_public_path__ + "static/media/I.41ff3957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/I.jpg
// module id = 77
// module chunks = 0